import type { Dayjs } from 'date';
import { useTranslation } from 'i18n';
import { SelectDatePicker } from 'ui';

import { DEFAULT_OPTIONS } from '../../utils/constants';

export const TimeFilter = ({
  onDateChange,
  defaultValue,
  options = DEFAULT_OPTIONS,
}: {
  onDateChange: ({ from, to }: { from: Dayjs; to: Dayjs }) => void;
  defaultValue?: Dayjs;
  options?: { label: string; value: Dayjs }[];
}) => {
  const { t } = useTranslation('orders');

  return (
    <SelectDatePicker
      size="small"
      fullWidth={false}
      onChange={onDateChange}
      defaultValue={defaultValue}
      options={options}
      label={t('timeFilter.label')}
      rangeSlotProps={{
        from: { label: t('timeFilter.startDate') },
        separator: t('timeFilter.separator'),
        to: { label: t('timeFilter.endDate') },
      }}
      sx={{
        minWidth: 120,
      }}
    />
  );
};
